<template>
    <div>
        <modal class="all-instead-landlord" :display="modalStatus.bizAllInsteadLandlord" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>所有房東替換為</h1>
            <div class="all-instead-landlord-wrap">
                <div class="description">
                    您在列表勾選的房源都將替換為您下面所選的房東
                </div>
                <div class="setting">
                    <label class="button-font input-label">
                        <div class="title">
                            房東
                        </div>
                    </label>
                    <div class="input-arear">
                        <select-landlord @getLandlordId="setLandlordId" msg="請選擇房東"></select-landlord>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setLandlord">更新</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import selectLandlord from '@/components/bussiness/mgtCategory/houseMgt/addHouse/selectLandlord.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import { mapGetters } from 'vuex'

import { 
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            value: false,
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 3000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 3000
                }
            },
        }
    },
    methods: {
        setLandlord: function () {
            if(this.value){
                this.$analyticsBiz.logEvent('所有房東替換為', { screen_name: '所有房東替換為'})
                this.$store.dispatch('updateBizBatchDispatchLandlord')
                .then(()=>{
                    this.closeModal()
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '成功替換房東',type: 'success'})
                })
            }else{
                this.alarm.error.msg = '尚未選擇房東'
                this.alarm.error.status = true
            }
        },
        setLandlordId: function (value) {
            this.value = value
            this.$store.dispatch('setBizBatchDispatchInsteadLandlordId', this.value)
        },
        closeModal: function () {
            this.$store.dispatch('setBizBatchDispatchInsteadLandlordId', null)
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizAllInsteadLandlord'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        selectLandlord,
        alarmMsgWhite
    }
}
</script>
<style lang="scss">
    #modal.all-instead-landlord{
        .modal-content{
            width: 372px;
            padding: 0 !important;
            .detail{
                .alarm-msg{
                    left: 50%;
                    margin-left: -70px;
                }
                >h1{
                    margin-top: 32px;
                    margin-bottom: 16px;
                }
                .all-instead-landlord-wrap{
                    padding: 0 32px 0 32px;
                    .description{
                        font-weight: 300;
                        line-height: 1.57;
                        margin-bottom: 20px;
                        color: #676362;
                    }
                    .setting{
                        margin-bottom: 60px;
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/allInsteadLandlord.vue